import { GiftPaymentPage } from './GiftPaymentPage'

export default GiftPaymentPage
// eslint-disable-next-line import/export
export * from './GiftPaymentPage'
